angular.module('picmonicng').directive('adaLabel', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.attr('aria-label', attr.adaLabel);
      element.attr('title', attr.adaLabel);

      attr.$observe('adaLabel', function (label) {
        element.attr('aria-label', label);
        element.attr('title', label);
      });
    },
  };
});
